import { RoomContent } from "../../components/app";

export default function Room() {
  return <RoomContent />;
}
